export type TemplateCategory =
  | "Randevu teyidi"
  | "Randevu hatırlatma"
  | "Gelmeyen müşteri takip"
  | "Paket bitiş hatırlatma"
  | "Paket yenileme mesajı"
  | "Memnuniyet sorgulama"
  | "Kampanya mesajı"
  | "Açık ödeme hatırlatma"
  | "Kurumsal cevap"
  | "Uygunsuz talep reddi";

export interface WhatsAppTemplate {
  id: string;
  name: string;
  category: TemplateCategory;
  content: string;
  active: boolean;
  createdAt: string;
}

export const whatsappTemplates: WhatsAppTemplate[] = [
  {
    id: "tpl-001",
    name: "Randevu Teyit Mesajı",
    category: "Randevu teyidi",
    content:
      "Merhaba {{musteri_adi}}, Kuğu Spa'dan {{tarih}} - {{saat}} için randevunuz alınmıştır. Randevunuzu onaylamak için lütfen bu mesaja 'EVET' yazın. İyi günler!",
    active: true,
    createdAt: "2026-01-01",
  },
  {
    id: "tpl-002",
    name: "Gün Öncesi Hatırlatma",
    category: "Randevu hatırlatma",
    content:
      "Merhaba {{musteri_adi}}, yarın {{tarih}} - {{saat}} randevunuz bulunmaktadır. Unutmayın, size özel bir deneyim hazırlıyoruz! Kuğu Spa",
    active: true,
    createdAt: "2026-01-01",
  },
  {
    id: "tpl-003",
    name: "Gelmeyen Müşteri Takip",
    category: "Gelmeyen müşteri takip",
    content:
      "Merhaba {{musteri_adi}}, bugün {{tarih}} - {{saat}} randevunuza gelmediğinizi fark ettik. Yeni bir randevu almak isterseniz bize yazabilirsiniz. Kuğu Spa",
    active: true,
    createdAt: "2026-01-01",
  },
  {
    id: "tpl-004",
    name: "Paket Bitiş Uyarısı",
    category: "Paket bitiş hatırlatma",
    content:
      "Merhaba {{musteri_adi}}, {{paket_adi}} paketinizde sadece {{kalan_seans}} seans kaldı. Yenilemek isterseniz özel fırsatlardan yararlanabilirsiniz. Kuğu Spa",
    active: true,
    createdAt: "2026-01-01",
  },
  {
    id: "tpl-005",
    name: "Paket Yenileme Teklifi",
    category: "Paket yenileme mesajı",
    content:
      "Merhaba {{musteri_adi}}, {{paket_adi}} paketinizi yenilerseniz %15 indirim fırsatından yararlanabilirsiniz. Detaylar için bize ulaşın. Kuğu Spa",
    active: true,
    createdAt: "2026-01-01",
  },
  {
    id: "tpl-006",
    name: "Memnuniyet Sorgulama",
    category: "Memnuniyet sorgulama",
    content:
      "Merhaba {{musteri_adi}}, dün aldığınız {{hizmet}} hizmetinden memnun kaldınız mı? Görüşleriniz bizim için çok değerli. Kuğu Spa",
    active: true,
    createdAt: "2026-01-01",
  },
  {
    id: "tpl-007",
    name: "Özel Kampanya Duyurusu",
    category: "Kampanya mesajı",
    content:
      "Merhaba {{musteri_adi}}, Kuğu Spa'da {{kampanya_adi}} kampanyası başladı! {{kampanya_detayi}} Detaylar için bizi arayın veya DM atın. Kuğu Spa",
    active: true,
    createdAt: "2026-01-01",
  },
  {
    id: "tpl-008",
    name: "Açık Ödeme Hatırlatma",
    category: "Açık ödeme hatırlatma",
    content:
      "Merhaba {{musteri_adi}}, Kuğu Spa hesabınızda ₺{{tutar}} açık ödeme bulunmaktadır. Ödeme yapmak isterseniz hesap bilgilerimizi paylaşabiliriz. Kuğu Spa",
    active: true,
    createdAt: "2026-01-01",
  },
  {
    id: "tpl-009",
    name: "Genel Kurumsal Cevap",
    category: "Kurumsal cevap",
    content:
      "Merhaba, Kuğu Spa'ya göstermiş olduğunuz ilgi için teşekkür ederiz. Size en kısa sürede dönüş yapacağız. İyi günler!",
    active: true,
    createdAt: "2026-01-01",
  },
  {
    id: "tpl-010",
    name: "Profesyonel Red Cevabı",
    category: "Uygunsuz talep reddi",
    content:
      "Saygıdeğer misafirimiz, Kuğu Spa profesyonel wellness hizmetleri sunan bir merkezdir. Talebiniz kurumumuzun hizmet standartlarına uymamaktadır. Sağlıklı ve profesyonel hizmetlerimizden yararlanmanızı önemle rica ederiz.",
    active: true,
    createdAt: "2026-01-01",
  },
];